import { useEffect, useRef } from 'react'
import { useAppSelector } from '@/store/hooks'

/**
 * Выбор типа нового экрана закрывается, как только автор переключил урок или
 * экран (в ленте, стрелками превью): окно открыто про ТОТ урок, где его открыли.
 */
export const useCloseOnSelectionChange = (onClose: () => void) => {
  const lessonId = useAppSelector((s) => s.editor.selectedLessonId)
  const blockId = useAppSelector((s) => s.editor.selectedBlockId)
  const opened = useRef({ lessonId, blockId })
  useEffect(() => {
    if (lessonId !== opened.current.lessonId || blockId !== opened.current.blockId) onClose()
  }, [lessonId, blockId, onClose])
}
